
import React, { useContext }  from 'react';
import { Route, Link } from "react-router-dom";
import TeacherLogin from '../pages/account/log-in/Teacher'
import customRequest from '../helpers/customRequest';
import redirect from '../components/redirect/redirect'
import message from '../components/message/message'
import Common from '../context/Common'
import { StudentLogin, models } from '@stem-sims/great-leaps-react-common'

class LogIn extends React.Component
{
    state = {
        submitting: false
    }
    submit = () =>
    {
        this.setState({submitting: true}, () => {
            var usernameInput = document.getElementById("username")
            var passwordInput = document.getElementById("password")
            
            models.login.post(usernameInput.value, passwordInput.value, this.props.type)
            .then((data) =>
            {
                this.setState({submitting: false})
                if (data.valid === true)
                {
                    this.props.updatePermissions()
                    .then(() => {
                        if (this.props.type === "customer") {
                            redirect.send("/dashboard")
                        }
                        else if (this.props.type === "student") {
                            redirect.send("/student/dashboard")
                        }
                        
                    })
                }

                else
                {
                    message.clear()
                    message.error(data.message)
                    this.checkAuth()
                    if (this.props.type === "student") {
                        document.getElementById("password").value = ""
                    }
                }
            })
        })
    }

    checkAuth = () => {
        this.props.updatePermissions()
        .then(() => {
            let auth = this.context?.auth
            if (auth == "customer") {
                redirect.send("/dashboard", () => {
                    message.error("You are already logged in.")
                })
            }
            else if (auth == "student") {
                redirect.send("/student/dashboard", () => {
                    message.error("You are already logged in.")
                })
            }
        })
    }

    static contextType = Common

    componentDidMount() {
        if (this.state.submitting == false) {
            this.checkAuth()
        }
    }

    render()
    {
        var { submitting } = this.state
        var { type } = this.props
        return (
            <React.Fragment>
                <h1>Log in to Great Leaps Digital</h1>

                <div class = "row subheader-text">
                    <div class = "col-sm-6">
                        <Link to = "/account/log-in/teacher" class = {`btn btn-secondary btn-lg ${type === "customer" ? "active" : ""}`}>Teacher</Link>
                    </div>
                    
                    <div class = "col-sm-6">
                        <Link to = "/account/log-in/student" class = {`btn btn-secondary btn-lg ${type === "student" ? "active" : ""}`}>Student</Link>
                    </div>
                </div>

                <Route exact path="/account/log-in/student" render={(props) => <StudentLogin  {...props} submitting = {submitting} submit = {this.submit} />} />
                <Route exact path="/account/log-in/teacher" render={(props) => <TeacherLogin  {...props} submitting = {submitting} submit = {this.submit} />} />

            </React.Fragment>

        )
    }
}

export default LogIn
